import {
  Button,
  Circle,
  Heading,
  Link,
  Text,
  VStack,
} from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import { TrashIcon } from 'components/icons';
import { ScreenWithSingleSection } from 'layouts/ScreenWithSingleSection';
import React from 'react';
import { HOME_PATH } from 'utils/routes';

const SpaceDeleted = () => (
  <ScreenWithSingleSection>
    <VStack spacing={5}>
      <Circle bg="blue.300" size="90px">
        <TrashIcon size="3x" color="white" />
      </Circle>
      <VStack>
        <Heading fontSize="xl">{t`Space deleted`}</Heading>
        <Text maxWidth="sm" textAlign="center">
          {t`The space and its content were erased`}
        </Text>

        <Button as={Link} to={HOME_PATH}>{t`Go home`}</Button>
      </VStack>
    </VStack>
  </ScreenWithSingleSection>
);

export default SpaceDeleted;
